export enum AddToOrRemoveFromCartE {
  Add = 'add_to_cart',
  Remove = 'remove_from_cart',
}
